module.exports = __webpack_public_path__ + "static/media/关于我们_02.9c5f7e3c.jpg";